/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/prefer-export-from */
import { Result } from '../Result/index.js';
import { isError as _isError, isLoading as _isLoading, isSuccess as _isSuccess, isReady as _isReady, getOrElse as _getOrElse, getOrElseW as _getOrElseW, chain as _chainW, match as _match, match as _matchI, map as _map, getTag as _getTag, combineI as _combineI, } from './AsyncStateN.js';
import { error as _error, loading as _loading, success as _success, notInitiated as _notInitiated, } from './base.js';
//#endregion
//#region constructors
export const loading = _loading;
export const success = _success;
export const error = _error;
//#endregion
//#region refinements
export const isSuccess = _isSuccess;
export const isError = _isError;
export const isLoading = _isLoading;
export const isReady = _isReady;
//#endregion
export const map = _map;
/**
 * Folding AsyncState using functions for each state type.
 * @param state AsyncState
 * @param matcher Matchers
 * @returns Union of values returned by mathcer functions
 */
export const match = _match;
/**
 * Non-curried version of `match`
 * @param state AsyncState
 * @param matcher Matchers
 * @returns Union of values returned by mathcer functions
 */
export const matchI = _matchI;
/**
 * Less strict version of [`chain`](#chain).
 *
 * @category instance operations
 * @since 2.6.0
 */
export const chainW = _chainW;
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category instance operations
 * @since 2.0.0
 */
export const chain = chainW;
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category instance operations
 */
export const mapLeft = (f) => (fa) => isError(fa) ? error(f(fa.error)) : fa;
//#region fp-ts interop
export const fromResult = (result) => {
    if (Result.isSuccess(result)) {
        return success(result.success);
    }
    return error(result.failure);
};
export const toResult = (as, onLoading) => {
    return isSuccess(as)
        ? Result.succeed(as.value)
        : Result.fail(isLoading(as) ? onLoading() : as.error);
};
//#endregion
//#region interop
/**
 * Takes a default and a nullable value, if the value is not nully, turn it into a `Success`, if the value is nully use
 * the provided default as a `Error`.
 */
export const fromNullable = (e) => (a) => a === null || a === undefined ? error(e) : success(a);
export const getOrElse = _getOrElse;
export const getOrElseW = _getOrElseW;
//#endregion
export const getTag = _getTag;
export function combineI(states, fn) {
    return _combineI(states, fn);
}
//# sourceMappingURL=AsyncState.js.map